import { render, staticRenderFns } from "./TheNotesDataTable.vue?vue&type=template&id=e9d3a31e&scoped=true"
import script from "./TheNotesDataTable.vue?vue&type=script&lang=js"
export * from "./TheNotesDataTable.vue?vue&type=script&lang=js"
import style0 from "./TheNotesDataTable.vue?vue&type=style&index=0&id=e9d3a31e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d3a31e",
  null
  
)

export default component.exports